import * as React from 'react'
import { Form, Box, Typography, Loader } from 'cs-kevlar-react'
import { EditModalActionBar } from '../../EditModalActionBar'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import { Formik } from 'formik'
import { MigrationError } from './MigrationError'
import { MigrationContext, MigrationResult } from '../../../api'

interface CreateMigrationProps {
  className?: string
  createMigration: (values: any, action: any) => void
  migrationContext: MigrationContext
  migrationResult: MigrationResult
  children: any
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    spacer: {
      flexGrow: 1,
      minHeight: 0,
    },
    root: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    content: {
      padding: theme.spacing(8),
    },
    scrollable: {
      overflowY: 'auto',
    },
  }),
)

const DEFAULT_VALUES = {}

export const CreateMigration: React.FunctionComponent<CreateMigrationProps> = ({
  createMigration,
  migrationContext,
  migrationResult,
  children,
}) => {
  const classes = useStyles({})
  return (
    <Formik initialValues={DEFAULT_VALUES} onSubmit={createMigration}>
      {formikProps => (
        <Form onSubmit={formikProps.handleSubmit} className={classes.root}>
          <Box className={classes.scrollable}>
            <MigrationError
              className={classes.content}
              context={migrationContext}
              result={migrationResult}
            />
            <Typography className={classes.content} variant="body1">
              There are no migrations in progress. Click below to start a new
              migration.
            </Typography>
            {formikProps.isSubmitting && (
              <Loader size="sm" text="Creating Migration" />
            )}
            {children}
          </Box>
          <Box className={classes.spacer}></Box>
          <EditModalActionBar
            canDelete={false}
            canCancel={false}
            formikProps={formikProps}
            saveText="Create Migration"
          />
        </Form>
      )}
    </Formik>
  )
}
